export const EMAIL_VALIDATION_MODE_SOFT = 'soft'
export const EMAIL_VALIDATION_MODE_HARD = 'hard'
export const EMAIL_VALIDATION_MODES = [
  { label: 'Hard Reject', value: EMAIL_VALIDATION_MODE_HARD },
  { label: 'Soft Reject', value: EMAIL_VALIDATION_MODE_SOFT }
]
export const SOFT_EMAIL_VALIDATION_DEBOUNCE_TIME = 2000
export const EMAIL_VALIDATION_API_URL = '/api/internal/email_address_external_verification?email='
